import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateNewMasterLevel extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/Create");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetAllMasterLevels extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAMasterLevel extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAMasterLevel extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAMasterLevel extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/Update");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetAllMastersLevelsLight extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/GetListLight");
  }
}

class UpdateUserMasterLevel extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleMasterRegular/UpdateUserStatus");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateNewMasterLevel,
  GetAllMasterLevels,
  DeleteAMasterLevel,
  GetAMasterLevel,
  UpdateAMasterLevel,
  GetAllMastersLevelsLight,
  UpdateUserMasterLevel,
};
